module.exports = __webpack_public_path__ + "img/env-poll-a@2x.73b95cf9.png";